import actions from './actions';

const {
	
	FETCH_COUNTRIES_BEGIN,
	FETCH_COUNTRIES_SUCCESS,
	FETCH_COUNTRIES_ERR,

	FETCH_STATES_BEGIN,
	FETCH_STATES_SUCCESS,
	FETCH_STATES_ERR,

	FETCH_CITIES_BEGIN,
	FETCH_CITIES_SUCCESS,
	FETCH_CITIES_ERR,

} = actions;

const initialStateFilter = {
	countries: null,
	states: null,
	cities: null,
	loading: false,
	error: null,
	detail: null,
};

const addressReducer = (state = initialStateFilter, action) => {
	const { type, data, err } = action;
	switch (type) {
		case FETCH_COUNTRIES_BEGIN:
			return {
				countries: null,
				loading: true,
				error: null,
				detail: null,
			};
		case FETCH_COUNTRIES_SUCCESS:
			return {
				countries: data,
				loading: false,
				error: null,
				detail: null,
			};
		case FETCH_COUNTRIES_ERR:
			return {
				countries: null,
				loading: false,
				error: err,
				detail: null,
			};

			case FETCH_STATES_BEGIN:
			return {
				states: null,
				loading: true,
				error: null,
				detail: null,
			};
		case FETCH_STATES_SUCCESS:
			return {
				states: data,
				loading: false,
				error: null,
				detail: null,
			};
		case FETCH_STATES_ERR:
			return {
				states: null,
				loading: false,
				error: err,
				detail: null,
			};

		case FETCH_CITIES_BEGIN:
			return {
				cities: null,
				loading: true,
				error: null,
				detail: null,
			};
		case FETCH_CITIES_SUCCESS:
			return {
				cities: data,
				loading: false,
				error: null,
				detail: null,
			};
		case FETCH_CITIES_ERR:
			return {
				cities: null,
				loading: false,
				error: err,
				detail: null,
			};
		
		default:
			return state;
	}
};

export default addressReducer;
